import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ArrowDown } from '../icons/arrow-down';
import MoreButton from '../more-button';
import styles from './dropdown-button.scss';
import { Themes } from '../../constants/themes';

const OpenButton = ({ text, isOpen, secondary }) => (
  <div
    className={classNames({
      [styles.openButton]: true,
      [styles.openButtonSecondary]: secondary,
      'button-primary-text-color': !secondary,
      'button-color': secondary,
    })}
  >
    <span>{text}</span>&nbsp;
    <span
      className={classNames({
        [styles.arrow]: true,
        [styles.arrowUp]: isOpen,
        'button-primary-icon-fill': !secondary,
        'button-secondary-icon-fill': secondary,
      })}
    >
      <ArrowDown />
    </span>
  </div>
);

export class DropdownButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.containerRef = React.createRef();
  }

  showComponent = () => {
    const { onDropdownShow } = this.props;
    this.setState({ isOpen: true });
    onDropdownShow && onDropdownShow();
  };

  hideComponent = () => {
    const { onDropdownHide } = this.props;
    this.setState({ isOpen: false });
    onDropdownHide && onDropdownHide();
  };

  getParentRef = () => this.containerRef;

  render = () => {
    const { className, children, isSmall = true, dataHook, label, secondary = false } = this.props;

    return (
      <div data-hook={dataHook} ref={this.containerRef}>
        <MoreButton
          ariaLabel={label}
          icon={<OpenButton isOpen={this.state.isOpen} text={label} secondary={secondary} />}
          className={classNames(styles.moreButtonContainer, {
            [styles.small]: isSmall,
          })}
          buttonClassName={classNames({
            [styles.moreButton]: true,
            [styles.moreButtonBorder]: secondary,
            'button-background-color': !secondary,
            'button-border-color': secondary,
            'button-color': secondary,
          })}
          actionsContainerClassName={classNames(styles.dropdown, className)}
          onHide={this.hideComponent}
          onShow={this.showComponent}
          parentRef={this.getParentRef}
          size={MoreButton.SIZE_EXTENDED}
          theme={Themes.BlackAndWhite}
        >
          {children}
        </MoreButton>
      </div>
    );
  };
}

DropdownButton.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  t: PropTypes.func.isRequired,
  isSmall: PropTypes.bool,
  onDropdownShow: PropTypes.func,
  onDropdownHide: PropTypes.func,
  secondary: PropTypes.bool,
};

DropdownButton.defaultProps = {
  dataHook: 'dropdown-select',
};

export default DropdownButton;
